import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { CheckCircle, ErrorOutline, HelpOutline } from '@mui/icons-material';
import type { AuditVarianceByGame } from '../../types/auditVarianceTypes';

interface AuditDynamicFormVarianceStatusIconCellProps {
  variance: AuditVarianceByGame | undefined;
}

const AuditDynamicFormVarianceStatusIconCell: React.FC<AuditDynamicFormVarianceStatusIconCellProps> = React.memo(({ variance }) => {
  const status = variance?.status ?? 'unknown';

  const icon = status === 'match'
    ? <CheckCircle sx={{ fontSize: 16, color: 'success.main' }} />
    : status === 'discrepancy'
      ? <ErrorOutline sx={{ fontSize: 16, color: 'error.main' }} />
      : <HelpOutline sx={{ fontSize: 16, color: 'text.secondary' }} />;

  const tooltip = status === 'match'
    ? 'Variance matches'
    : status === 'discrepancy'
      ? 'Variance discrepancy'
      : 'Run simulation or refresh to view variance';

  return (
    <Box
      sx={{
        minWidth: 22,
        width: 22,
        maxWidth: 22,
        mx: 0,
        height: '17px',
        maxHeight: '17px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Tooltip title={tooltip} arrow>
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>{icon}</Box>
      </Tooltip>
    </Box>
  );
});

AuditDynamicFormVarianceStatusIconCell.displayName = 'AuditDynamicFormVarianceStatusIconCell';

export default AuditDynamicFormVarianceStatusIconCell;
